import script from "./Signup.vue?vue&type=script&setup=true&lang=js"
export * from "./Signup.vue?vue&type=script&setup=true&lang=js"

import "./Signup.vue?vue&type=style&index=0&id=1ccc4447&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ccc4447"]])

export default __exports__